/** Route names and hash parsing (pure; no DOM access). */
export const ROUTES = ['live', 'analysis', 'settings', 'selftest'] as const;
export type Route = (typeof ROUTES)[number];

export function parseHash(hash: string): Route {
  const name = hash.replace(/^#\/?/, '').split(/[/?]/)[0] ?? '';
  return (ROUTES as readonly string[]).includes(name) ? (name as Route) : 'live';
}
